module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("6UVE8"))).then(() => parcelRequire('amnsQ'));